import { PropsWithChildren } from 'react'
import { useFiltersApi } from '../../../hooks'

export const WithNodesQuery: React.FC<PropsWithChildren> = ({ children }) => {
    const { useNodesQuery } = useFiltersApi()
    useNodesQuery()

    return children
}
